import _ from 'lodash';

function toMinutes({ days, hours, mins }) {
  const d = _.isString(days) ? parseInt(days, 10) : days;
  const h = _.isString(hours) ? parseInt(hours, 10) : hours;
  const m = _.isString(mins) ? parseInt(mins, 10) : mins;

  if (_.isNumber(d) || _.isNumber(h) || _.isNumber(m)) {
    return ((d || 0) * 24 * 60) + ((h || 0) * 60) + (m || 0);
  }

  return null;
}

function fromMinutes(minutes) {
  if (!_.isNumber(minutes)) {
    return {
      days: null,
      hours: null,
      mins: null,
    };
  }

  let days = 0;
  let hours = 0;
  let mins = minutes;

  if (mins > 59) {
    hours = Math.floor(mins / 60);
    mins -= hours * 60;

    if (hours > 23) {
      days = Math.floor(hours / 24);
      hours -= days * 24;
    }
  }

  return { days, hours, mins };
}

function pluralize(val, str) {
  if (val > 1) {
    return `${str}s`;
  }

  return str;
}

function minsToString(mins) {
  if (!mins) {
    return '';
  }

  let d = 0;
  let h = 0;
  let m = 0;
  let str = '';

  if (mins > 59) {
    h = Math.floor(mins / 60);
    m = mins % 60;

    if (h > 23) {
      d = Math.floor(h / 24);
      h %= 24;
      str = `${d} ${pluralize(d, 'day')} `;

      if (h > 0) {
        str += `${h} ${pluralize(h, 'hour')} `;
      }
    } else {
      str = `${h} ${pluralize(h, 'hour')} `;
    }
  } else {
    m = mins;
  }

  if (m > 0) {
    str += `${m} ${pluralize(m, 'minute')}`;
  }

  return str;
}

export {
  toMinutes,
  fromMinutes,
  minsToString,
};



// WEBPACK FOOTER //
// ./src/utils/time.js